<div class="center-small-container">

  <h1 class="page-title-center">Name change</h1>

  <form class="account-update-form gap-15" [formGroup]="nameForm" (ngSubmit)="updateName()">
    <mat-form-field appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput formControlName="first_name" />
    </mat-form-field>
  
    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="last_name" />
    </mat-form-field>

    <button
      mat-flat-button
      class="mat-button-squared-full-width"
      type="submit"
      matTooltip="Update"
      [disabled]="nameForm.invalid"
    >
    Update
    </button>

  </form>

  <br />

  <div class="bottom-actions">
    <button
      mat-button
      (click)="goBack()"
      matTooltip="Go back"
    >
      Go back
    </button>
  </div>

</div>


